import React,{ useState, useEffect, useMemo } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss';
import AddToWish from "../../../../module/addtowish";
import { Iconfont } from "../../../../../../../components/icon/iconfont";
import { FormattedMessage, useIntl } from "react-intl";
import Cache from "../../../../../../../../utils/cache";
import _ from "lodash"
import { fetchStockOutSubscribe, fetchStockOutUnSubscribe } from "../../../../../../../../api";
import { BigButton } from "../../../../../../components/button";
import { BlackMask } from "../../../../../../../components/mask";
import { isFlashSales, unitPrice } from "../../../../../../../../utils/product";
import { getOriginalSize } from "../../../../../../../utils/sensor";
import NormalSwiper from "../../../../../../../components/swiper/autowidth";


const StockOutModal = props =>{
    useStyles(classes);
    return (
        <React.Fragment>
            <div className={classes.stockOutModalContainer}>
                <div className={classes.Hd}>
                    <Iconfont onClick={props.onClose}>&#xe7c9;</Iconfont>
                </div>
                <div className={classes.Bd}>
                    <p><FormattedMessage id="if_the_item_comes_back" defaultMessage="If the item comes back into stock within 30 days, we will send you an email." /></p>
                    <button onClick={props.onClose}><FormattedMessage id="ok" defaultMessage="OK" /></button>
                </div>
            </div>

            <BlackMask onClick={props.onClose} />
        </React.Fragment>
    )
}

const RollingDiscount = props =>{
    const { rollingMessages } = props;

    return <NormalSwiper 
        options={{
            direction: 'vertical',
            loop: rollingMessages?.length > 1,
            autoplay: rollingMessages?.length > 1 ? {
                disableOnInteraction:false,
                delay: 5000
            } : false
        }} 
        items={rollingMessages} 
        className={classes.RollingDiscount} 
        render={(message, index) =>(
            <a className={classes.DiscountLink} key={message?.msg+index}>
                {
                    message?.iconImage && <img src={message.iconImage} alt="" />
                }
                
                <span dangerouslySetInnerHTML={{ __html: message?.msg }}></span>
            </a>
        )}
    />
}

const AddToCartContainer = props =>{
    useStyles(classes);
    const { productHooks } = props;
    const { 
        selectedProduct, 
        selectedVariant, 
        productAddToCart, 
        setQuantity, 
        quantity, 
        isBeautyMakeup, 
        carting, 
        productVO,
    } = productHooks;
    const [isNotifyMe,setIsNotifyMe] = useState();
    const [earnPoints,setEarnPoints] = useState(false)
    const [notifyLoading,setNotifyLoading] = useState(false);
    const [showModal,setShowModal] = useState(false);

    const intl = useIntl();

    const isEnabled = v => {
		if (!v) return true
		return v.status === '1' && v.inventory > 0 || (v.domesticDelivery && v.domesticDelivery.enabled && v.domesticDelivery.inventory > 0)
	}
    const isDisabled = !isEnabled(selectedVariant) || (isFlashSales(selectedProduct) && selectedProduct?.promotion?.salesQty >= selectedProduct?.promotion?.totalQty);

    const getStockOutProduct = (variantId) =>{
        let stockOutItem = Cache.get("shortagenotification");
        return stockOutItem?.findIndex(item =>item === variantId);
    }
    
    useEffect(() => {
        const nitifyMe = getStockOutProduct(selectedVariant?.id) >= 0
        setIsNotifyMe(nitifyMe)
    }, [])

    useEffect(() =>{
        setIsNotifyMe(getStockOutProduct(selectedVariant?.id) >= 0);
    },[selectedVariant?.id]);

    const notifyMeEnevt = async (variantId) =>{
        let stockOutItem = Cache.get("shortagenotification");
        stockOutItem = _.cloneDeep(stockOutItem);
        let data,flag;
        setNotifyLoading(true);
        if(stockOutItem){
            let index = getStockOutProduct(variantId);
            if(isNotifyMe){
                data = await fetchStockOutUnSubscribe(variantId);
                if(data){
                    stockOutItem.splice(index,1);
                    flag = false;
                    setIsNotifyMe(false);
                }
            }else{
                data = await fetchStockOutSubscribe(variantId);
                if(data){
                    stockOutItem.push(variantId);
                    flag = true;
                    setIsNotifyMe(true);
                }
            }
        }else{
            data = await fetchStockOutSubscribe(variantId);
            if(data){
                stockOutItem = [variantId];
                flag = true;
                setIsNotifyMe(true);
            }
            
        }
        setNotifyLoading(false);
        if(data){
            await Cache.set("shortagenotification",stockOutItem);
            setShowModal(flag);

            if(window.GeekoSensors){
				window.GeekoSensors.Track('ELClick', {
					clicks:"notifyme",
					variantId:selectedVariant?.id,
					size: getOriginalSize(selectedVariant?.size),
					color:selectedVariant.color,
					product_sku:selectedVariant?.sku
				})
			}
        }
    }

    const findSimilarEvent = () =>{
        if(window.GeekoSensors){
            window.GeekoSensors.Track('ELClick', {
                clicks:"findsimilar",
                variantId:selectedVariant?.id,
                size: getOriginalSize(selectedVariant?.size),
                color:selectedVariant?.color,
                product_sku:selectedVariant?.sku
            })
        }

        window.location.href = `/i/similar/products?productId=${selectedProduct.id}`;
    }

    

    const addToCartHandle = async (isBuy) =>{
          
        if(!selectedVariant){
            alert(intl.formatMessage({id:'please_select_size', defaultMessage:'Please Select a Size'}));


            if(window.GeekoSensors){
                window.GeekoSensors.Track('Addtocart', {
                    is_success: false,
                    product_id: selectedProduct?.id,
                    product_qty: quantity,
                })
            }

            return
        }

        const response = await productAddToCart();

        if(isBuy){
            if (window.GeekoSensors) {
                window.GeekoSensors.Track('BuyNowClick', {
                    page_type: window?.sourceTitle || window?.currentPage,
                    is_success: true,
                    ali_request_id: selectedProduct?.sensor?.ali_request_id,
                    geeko_request_id: selectedProduct?.sensor?.geeko_request_id,
                    geeko_experiment_id: selectedProduct?.sensor?.geeko_experiment_id,
                    ali_experiment_id: selectedProduct?.sensor?.ali_experiment_id,
                    data_source: selectedProduct?.sensor?.data_source,
                    data_layer_name: selectedProduct?.sensor?.data_layer_name,
                    data_tracking_records: selectedProduct?.sensor?.data_tracking_records
                })

                window.GeekoSensors.Track('BuyNowDetail', {
                    product_id: selectedProduct?.id,
                    product_qty: quantity,
                    list_sort: window?.fromFilters?.list_sort || '',
                    list_attribute: (window?.fromFilters?.list_attribute || '').split(','),
                    product_position: window?.fromFilters?.product_position || '',
                    ali_request_id: selectedProduct?.sensor?.ali_request_id,
                    geeko_request_id: selectedProduct?.sensor?.geeko_request_id,
                    geeko_experiment_id: selectedProduct?.sensor?.geeko_experiment_id,
                    ali_experiment_id: selectedProduct?.sensor?.ali_experiment_id,
                    data_source: selectedProduct?.sensor?.data_source,
                    data_layer_name: selectedProduct?.sensor?.data_layer_name,
                    data_tracking_records: selectedProduct?.sensor?.data_tracking_records
                })
            }
            if(response.code === 200){
                window.location.href = '/cart';
            }
        }
    }

    return <div className={classes.Container}>
        {
            isBeautyMakeup && <div className={classes.QtyContainer}>
                <p className={classes.Title}><FormattedMessage id="qty" defaultMessage="Qty" /></p>

                <div className={classes.Content}>
                    <Iconfont className={classes.Reduce} onClick={() => {
                        setQuantity(quantity > 2? (quantity-1): 1)
                    }}>&#xe6ba;</Iconfont>
                    <span className={classes.Num}>
                        <input onChange={e => {setQuantity(parseInt(e.target.value))}} className={classes.Qty} value={quantity} type="number" />
                    </span>
                    <Iconfont className={classes.Add} onClick={() => {
                        setQuantity(quantity+1)
                    }}>&#xe6b9;</Iconfont>
                </div>
            </div>
        }


        <div className={classes.AddToCartContainer}>
            {
                isDisabled && <div className={classes.StockOutMessage}>
                    {
                        isNotifyMe ? (<FormattedMessage id="you_haveArrival_reminder" defaultMessage="You have already subscribed to the arrival reminder" />) : (<FormattedMessage id="sold_out_notification" defaultMessage="The item is sold out, click notify me for restock notification" />)
                    }
                </div>
            }

            <div className={classes.BtnContainer}>
                <div className={classes.First}>
                    {
                        isDisabled?(
                            <button className={`${classes.NormalBtn} ${classes.FindSimlar}`} onClick={findSimilarEvent}><FormattedMessage id="find_simlar" defaultMessage="Find Simlar" /></button>
                        ):(
                            <BigButton 
                                className={`${classes.NormalBtn}`} 
                                onClick={()=>addToCartHandle(false)}
                                disabled={productVO?.isLogisticsInCountryIsNotSupported || isDisabled}
                                loading={carting}
                            >
                                <FormattedMessage id="add_to_cart" defaultMessage="Add to Cart" />
                            </BigButton>
                        )
                    }
                </div>

                <div className={classes.Second}>
                    {
                        isDisabled?(
                            <BigButton
                                className={`${classes.NormalBtn}`}
                                loading={notifyLoading}
                                onClick={() =>notifyMeEnevt(selectedVariant?.id)}
                            >
                                {
                                    isNotifyMe ? (<FormattedMessage id="un_subscribe" defaultMessage="UNSUBSCRIBE" />) : (<FormattedMessage id="notify_me" defaultMessage="Notify Me" />)
                                }
                            </BigButton>
                        ):(
                            <BigButton 
                                className={`${classes.NormalBtn} ${classes.Buy}`}
                                onClick={()=>addToCartHandle(true)}
                                disabled={productVO?.isLogisticsInCountryIsNotSupported || isDisabled}
                                loading={carting}
                            >
                                <FormattedMessage id="buy" defaultMessage="Buy" />
                            </BigButton>
                        )
                    }
                </div>
                
                <div className={classes.Third}>
                    <div className={classes.AddToWish}>
                        <AddToWish 
                            productId={selectedProduct?.id}
                        />
                    </div>
                </div>
            </div>
        </div>

        {
            productVO?.rollingMessages?.length > 0 && <RollingDiscount rollingMessages={productVO.rollingMessages} />
        }
        
        {
            selectedProduct?.earnPointsMsg && <div className={classes.EarnPointsBox}>
                <span dangerouslySetInnerHTML={{ __html: selectedProduct.earnPointsMsg }}></span>
                <Iconfont 
                    className={classes.Icon}
                    onMouseEnter={()=>setEarnPoints(true)}
                    onMouseLeave={()=>setEarnPoints(false)}
                >&#xe6b8;</Iconfont>

                {
                    selectedProduct?.earnPointsDsc && earnPoints && <>
                        <div className={`${classes.conditionMessage}`}>{selectedProduct.earnPointsDsc}</div>
                        <span className={`${classes.conditionJt}`}></span>
                    </>
                }
            </div>
        }
        
        {
            showModal && <StockOutModal onClose={() =>setShowModal(false)} />
        }
    </div>
    
}

export default AddToCartContainer;